import styled, { keyframes } from "styled-components";

const skeletonLoadingAnimate = keyframes`
  from {
    background-color: hsl(200, 20%, 80%);
  }
  to {
    background-color: hsl(200, 20%, 95%);
  }
`;

export const CategoryLoading = styled.div`
  width: 100%;
  height: 12px;
  border-radius: 8px;
  animation: ${skeletonLoadingAnimate} 2s linear infinite;
`;
